import smoothAnchors from './modules/smooth-anchors';
import homeHero from './modules/home-hero';
import forms from './modules/form-handler';
import partnersSlider from './modules/partners-slider';
// import dropdown from './modules/dropdown';
import accordion from './modules/accordion';

smoothAnchors();
homeHero();
forms();
partnersSlider();
// dropdown();
accordion();


$('[data-nav-trigger]').on('click', () => {
  $('html').toggleClass('show-nav');
})
$('[data-nav-close]').on('click', () => {
  $('html').removeClass('show-nav');
})


$('[data-fancybox]').fancybox();

